// S27: Error 403 - Forbidden Access
import { Result, Button } from 'antd';
import { LockOutlined, HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

export function Error403() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '24px',
      }}
    >
      <Result
        status="403"
        icon={<LockOutlined style={{ fontSize: '72px' }} />}
        title="You don't have access to this page"
        subTitle="If you believe this is a mistake, contact the admin of DivvyStash."
        extra={
          <Button
            type="primary"
            size="large"
            icon={<HomeOutlined />}
            onClick={() => navigate('/')}
          >
            Go to Dashboard
          </Button>
        }
      />
    </div>
  );
}
